import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import ru from 'vuetify/src/locale/ru'
import '@fortawesome/fontawesome-free/css/all.css'

Vue.use(Vuetify)

export default new Vuetify({
  icons: {
    iconfont: 'fa'
  },
  lang: {
    locales: { ru },
    current: 'ru'
  },
  theme: {
    themes: {
      light: {
        primary: '#5777f5',
        secondary: '#073763',
        accent: '#f1c232',
        success: '#4caf50',
        error: '#f27008'
        // primary: '#038200',
        // secondary: '#073763',
        // accent: '#f1c232',
        // success: '#4caf50',
        // error: '#ff4000'
      },
      dark: {
        primary: '#4018e2',
        secondary: '#517392',
        accent: '#f1c232',
        success: '#82c785',
        error: '#e27b36'
        // primary: '#55d950',
        // secondary: '#517392',
        // accent: '#f1c232',
        // success: '#82c785',
        // error: '#ff4000'
      }
      // themes: {
      //   light: {
      //     primary: '#197840',
      //     secondary: '#073763',
      //     accent: '#f1c232',
      //     success: '#4caf50',
      //     error: '#b00020'
      //   },
      //   dark: {
      //     primary: '#5ea179',
      //     secondary: '#517392',
      //     accent: '#f1c232',
      //     success: '#82c785',
      //     error: '#c84d63'
      //   }
    }
  }
})
